import permissions from "@/config/permissions";
import JwtService from "@/jwt.service";
import _ from 'lodash';
export default {
    data() {
      return {
        allPermission: permissions,
        user: JwtService.getUser()
      };
    },
    methods:{
      hasPermissions(permision) {
          let namePermission = this.allPermission[permision];
          if(this.user && this.user.listPermission){
            return this.user.listPermission.includes(namePermission) ? true : false;
          }
          return false;
      },
      hasPermissionsList(permisions) {
        if(permisions && permisions.length > 1){
          if(this.user && this.user.listPermission){
            let diff = _.difference(permisions, this.user.listPermission);
            return diff.length != permisions.length ? true : false;
          }
        }else{
          if(this.user && this.user.listPermission){
            let diff = _.difference(permisions, this.user.listPermission);
            return diff.length == 0 ? true : false;
          }
        }
          return false;
      }
    }
}